define(function (require) {
	const Marionette = require('backbone.marionette');
	const Radio = require('backbone.radio');
	const GuestItemView = require('./v_itv_login_guest');
	const tpl = require('./templates/t_lov_login_guest.hbs');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			GuestItemViewRegion: '#guestItemView',
		},
		initialize: function (options) {
			this.config = options.config;
		},
		events: {
			'click input': 'guestClicked'
		},
		guestClicked: function (e) {
			// prevent model updates from rendering
			e.preventDefault();
			e.stopPropagation();

			if (__DEV__) console.log('lovGuest-guestClicked e', e, 'this', this);
			this.config.loginChannel.command('go:authenticated');
		},
		onRender: function () {
		},
		onShow: function () {
			var guestItemView = new GuestItemView({
				config: this.config
			});
			this.GuestItemViewRegion.show(guestItemView);
		},
		templateHelpers: function () {
			return {};
		}
	});
});
